// Libs
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import { ReactComponent as LoaderSvg } from "./loader.svg";

// Styles
import styles from "./OverlayLoader.css";

import DATA_HOOKS from "./OverlayLoader.datahooks";

export default function OverlayLoader({ className, isLoading, isFullWidth }) {
  return (
    <div
      className={classNames(
        className,
        styles.overlay,
        { [styles.isLoading]: isLoading },
        { [styles.fullWidth]: isFullWidth }
      )}
      data-hook={DATA_HOOKS.ROOT}
    >
      <div className={styles.container}>
        <LoaderSvg className={styles.svg} />
      </div>
    </div>
  );
}

OverlayLoader.propTypes = {
  /**
   * className to enable custom styles
   */
  className: PropTypes.string,
  /**
   * indicates loading state
   */
  isLoading: PropTypes.bool.isRequired,
  /**
   * indicates whether to cover the full screen (including sidebar)
   */
  isFullWidth: PropTypes.bool
};
